// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, SpeedDial, SpeedDialIcon, SpeedDialAction, Tab, Tabs, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// TODO: Import MUI icon
import { MenuBook } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import Slide from '../Slide_LT.jpg';

import BoxSubPage from '../../Common/BoxSubPage';
import BoxImage from '../../Common/BoxImage';
import { BoxGridColumnsContainer } from '../../Common/BoxGridColumns';

const EnglishEducation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component EnglishEducation Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const actions = [
        'English Morning Assembly MC Training',
        'Choral Speaking',
        'Solo Verse Speaking, Public Speaking Solo, Dramatic Duologue and News Feature Presentation',
        'Sports Day'
    ];
    const [value, setValue] = React.useState(actions[0]);
    const [open, setOpen] = React.useState(false);

    // TODO: Define event
    const theme = useTheme();

    const handleChange = (event, newValue) => { setValue(newValue) };

    React.useEffect(() => { window.scrollTo(0, 0); }, [value]);
    React.useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.innerHeight + window.scrollY;
            const documentHeight = document.documentElement.scrollHeight;

            if (documentHeight - scrollPosition < 200) {
                setOpen(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // TODO: Return component
    return (
        <BoxSubPage
            id="EnglishEducation"
            image={Slide}
            title={Text.Top.Menu['LT'].Title[context.language]}
            subtitles={Text.Top.Menu['LT'].Subtitles}
        >
            <Box sx={{ display: { xs: 'none', md: 'inline' }, mb: 2, width: 1 }}>
                <Tabs value={value} onChange={handleChange}>
                    {actions.map((action) => <Tab key={action} icon={<MenuBook />} value={action} label={action} sx={{ maxWidth:'224px' }} wrapped />)}
                </Tabs>
            </Box>
            <Typography variant="h6" sx={{ color: 'primary.main', mb: 2, display: { xs: 'inline', md: 'none' } }}>{value}</Typography>
            <SpeedDial
                ariaLabel="SpeedDial tooltip example"
                sx={{ alignItems: 'end', display: { xs: 'flex', md: 'none' }, position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                open={open}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action}
                        FabProps={{
                            sx: {
                                backgroundImage: `linear-gradient(90deg, ${theme.palette.secondary.dark}, ${theme.palette.secondary.light})`,
                                backgroundSize: '200% 200%',
                                justifyContent: 'start',
                                height: 'auto', 
                                maxWidth: '300px',
                                padding: '8px 8px',
                                '&:hover': { backgroundColor: 'secondary.light', },
                            },
                            variant: 'extended'
                        }}
                        icon={
                            <Typography
                                style={{
                                    alignItems: 'center',
                                    color: 'black',
                                    display: 'flex',
                                    gap: 8,
                                    textAlign: 'left',
                                    textDecoration: 'none',
                                }}
                                variant="body2"
                            >
                                <MenuBook />
                                <span dangerouslySetInnerHTML={{ __html: action }}></span>
                            </Typography>
                        }
                        onClick={() => {
                            setOpen(false);
                            setValue(action);
                        }}
                    />
                ))}
            </SpeedDial>
            {value === actions[0] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssemblyMCTraining_03.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        At TYH, we believe in nurturing confident and articulate speakers. Our Native English Teachers regularly conduct comprehensive training sessions for our English Ambassadors, preparing them to host English morning assemblies in front of the entire school community. These training sessions cover critical skills such as pronunciation, effective body language, and voice projection, all of which are essential for impactful presentations. Students engage in practical exercises that not only enhance their speaking abilities but also build their self-esteem and public speaking skills. By participating in this, our students not only gain the confidence to speak in front of an audience but also develop valuable skills that will benefit them in their academic and professional futures.
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssemblyMCTraining_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishMorningAssemblyMCTraining_02.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[1] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ChoralSpeaking.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        TYH takes great pride in our 2 choral speaking teams (Form 1 and Form 3), led and trained by our Native English Teachers. The teams compromise of dedicated, ambitious English learners who are passionate about performing on-stage. The training sessions provide a springboard for students to discover the value of team collaboration and having trust in one another. The teams represent TYH in reputable competitions such as the Hong Kong Schools Speech Festival and the Greater Bay Speech Festival.
                    </Typography>
                    <Typography>Form 1 Choral Speaking Team (2025-26)</Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ChoralSpeakingF1_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ChoralSpeakingF1_02.jpg" />
                    </BoxGridColumnsContainer>
                    <Typography>Form 3 Choral Speaking Team (2025-26)</Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ChoralSpeakingF3_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ChoralSpeakingF3_02.jpg" />
                    </BoxGridColumnsContainer>
                    <Typography>Form 1 Choral Speaking Team (2024-25)</Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ChoralSpeakingF1_03.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ChoralSpeakingF1_04.jpg" />
                    </BoxGridColumnsContainer>
                    <Typography>Form 3 Choral Speaking Team (2024-25)</Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ChoralSpeakingF3_03.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/ChoralSpeakingF3_04.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[2] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SoloVerseSpeaking_01.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        In preparation for the Hong Kong Schools Speech Festival, students across all forms are encouraged to explore the exciting challenges of Solo Verse Speaking, Public Speaking Solo, Dramatic Duologue, and News Feature Presentation. English teachers regularly train, guide and support students individually and in small groups. Students are able to enhance and polish their verbal skills, including pronunciation, articulation, intonation and stress. Students who choose to embark on this Speech Festival journey find the experience incredibly rewarding and show great improvement in their fluency and confidence when communicating in English!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SoloVerseSpeaking_02.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SoloVerseSpeaking_03.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[3] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SportsDayMCTraining_03.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        At TYH, we recognise that real-world interactions and explorations play a vital role in enriching students' appreciation of language learning; therefore we place great value in training students for roles outside of the classroom, including offering specialised training for students to host our Sports Day. Led by our Native English Teachers, students learn how to deliver bilingual announcements, ensuring that every member of our school community can engage with the excitement of the event. This focus on bilingual communication not only enhances inclusivity but also prepares students for various real-world scenarios where language skills are invaluable.
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Throughout the training, students gain hands-on experience in sports commentary, developing skills such as effective communication, quick decision-making, and an understanding of sports terminology. They practice announcing scores, player highlights, and event updates, all while bringing energy and enthusiasm to their presentations. In addition to technical skills, this training fosters teamwork as students work together to create a cohesive commentary experience. They learn the importance of timing, rhythm, and audience engagement, all crucial elements in delivering captivating sports announcements.
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SportsDayMCTraining_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SportsDayMCTraining_02.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
        </BoxSubPage >
    );
};
export default EnglishEducation;